import React from 'react'
import { Heading } from '@myxplor/ui'
import { FormDate } from '@myxplor/forms'
import ProviderLevelReportContainer from '../container'
import { afterCCSStarted } from './helpers'
import { momentFromDate, dayFormat } from '../../../week'
import { ReportEmailAddress } from './_email'

const reportLabel = 'Provider Events Management Report'

const FormFields = ({ values, errors, onChange }) => (
  <fieldset>
    <Heading small>{reportLabel}</Heading>

    <div className="providerReportForm--dateRange">
      <FormDate
        name="start_date"
        label="Start Date"
        value={values.start_date}
        errors={errors.start_date}
        onChange={onChange}
        required
        today
      />

      <FormDate
        name="end_date"
        label="End Date"
        value={values.end_date}
        errors={errors.end_date}
        onChange={onChange}
        required
        today
      />
    </div>

    <ReportEmailAddress
      reportLabel={reportLabel}
      value={values.email_address}
      errors={errors.email_address}
      onChange={onChange}
    />
  </fieldset>
)

const formEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/providers/${gov_id}/provider-reports/events-management`

const validate = ({ start_date }) => afterCCSStarted({ week_start_date: start_date })

export const ProviderLevelReportEventsManagement = ({ gov_id, resetCurrentReport }) => (
  <ProviderLevelReportContainer
    url={formEndPoint({ gov_id })}
    name={reportLabel}
    formOptions={{
      validate,
      defaultValues: {
        end_date: dayFormat(momentFromDate()),
      },
    }}
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
  />
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/reports/events_management.jsx